import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FlipCard.css';

export type FlipCardAccent = 'navy' | 'gold' | 'sky' | 'teal';

interface FlipCardProps {
  icon: string;
  title: string;
  frontText: string;
  backText: string;
  backLink: string;
  backLinkLabel: string;
  hint?: string;
  accent?: FlipCardAccent;
}

const FlipCard: React.FC<FlipCardProps> = ({
  icon,
  title,
  frontText,
  backText,
  backLink,
  backLinkLabel,
  hint,
  accent = 'navy',
}) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`flip-card accent-${accent} ${flipped ? 'is-flipped' : ''}`}
      onClick={() => setFlipped((prev) => !prev)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setFlipped((prev) => !prev);
        }
      }}
      role="button"
      tabIndex={0}
      aria-pressed={flipped}
    >
      <div className="flip-card-inner">
        <div className="flip-card-face flip-card-front">
          <div className="flip-card-icon" aria-hidden="true">
            {icon}
          </div>
          <h3>{title}</h3>
          <p>{frontText}</p>
          {hint && <span className="flip-card-hint">{hint}</span>}
        </div>
        <div className="flip-card-face flip-card-back">
          <h3>{title}</h3>
          <p>{backText}</p>
          <Link to={backLink} className="flip-card-link" onClick={(e) => e.stopPropagation()}>
            {backLinkLabel}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
